import React, { Fragment } from 'react'
import { useCallback, useMemo } from 'sb-hooks'

import { AccordionButton, AccordionItem, AccordionPanel } from 'components/_new/ui/Accordion'
import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import NavList from 'components/_new/NavList/NavList'
import Href from 'components/_new/ui/Href/Href'

import ItemView from './ItemView/ItemView'

import s from './NavListItem.scss'
import messages from './messages'


const checkIfActive = (to, subNav, pathname) => (
  to === pathname
  || subNav && subNav.some(({ to, subNav }) => checkIfActive(to, subNav, pathname))
)

const NavListItem = ({ item, pathname, level, minSubNavLengthToDisplay, closeNav }) => {
  const { title, to, href, iconName, emojiIcon, toTab, dataTestId, id, isSeparator, subNav, onClick } = item

  const isActive = useMemo(
    () => checkIfActive(to, subNav, pathname),
    [ to, subNav, pathname ]
  )

  const handleClick = useCallback((event) => {
    if (typeof onClick === 'function') {
      onClick(event)
    }

    if (typeof closeNav === 'function') {
      closeNav()
    }
  }, [ onClick, closeNav ])

  if (isSeparator) {
    return title ? (
      <Box mt="24" mb="8" ml="16">
        <Text message={title} size="12-24" semibold uppercase color="gray" />
      </Box>
    ) : (
      <Box className={s.line} mt="8" mb="8" ml="16" />
    )
  }

  if (subNav && subNav.length >= minSubNavLengthToDisplay) {
    return (
      <AccordionItem>
        {
          ({ isOpen }) => (
            <Fragment>
              <AccordionButton className={s.button} data-testid={dataTestId}>
                <ItemView
                  message={title}
                  iconName={iconName}
                  emojiIcon={emojiIcon}
                  isActive={isActive}
                  isOpen={isOpen}
                  level={level}
                  hasSubNav
                />
              </AccordionButton>
              <AccordionPanel withMeasure={false}>
                {
                  Boolean(to || toTab || href) && (
                    <Href
                      id={id}
                      to={to}
                      href={href}
                      toTab={toTab}
                      onClick={handleClick}
                      data-testid={`seeAll${dataTestId}`}
                    >
                      <ItemView
                        message={messages.seeAll}
                        isActive={pathname === to}
                        level={level + 1}
                      />
                    </Href>
                  )
                }
                <NavList
                  items={subNav}
                  pathname={pathname}
                  level={level + 1}
                  minSubNavLengthToDisplay={minSubNavLengthToDisplay}
                  closeNav={closeNav}
                />
              </AccordionPanel>
            </Fragment>
          )
        }
      </AccordionItem>
    )
  }

  return to || toTab || href ? (
    <Href to={to} toTab={toTab} href={href} id={id} onClick={handleClick}>
      <ItemView
        message={title}
        iconName={iconName}
        emojiIcon={emojiIcon}
        isActive={isActive}
        level={level}
      />
    </Href>
  ) : (
    <button className={s.button} id={id} type="button" onClick={handleClick} data-testid={dataTestId}>
      <ItemView
        message={title}
        iconName={iconName}
        emojiIcon={emojiIcon}
        isActive={isActive}
        level={level}
      />
    </button>
  )
}

export default NavListItem
